import { Button, Card, Col, DatePicker, Form, Modal, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GoBackLink from "../../../../../components/common/GoBackLink";
import PageHeading from "../../../../../components/common/PageHeading";
import RightBar from "../../../../../components/common/RightBar";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";
import Notes from "../../../../../components/common/Notes";

import { FiEdit } from "react-icons/fi";

import "./BillsItem.css";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";
import { billsAllData } from "../../../../../data/accounting";


function BillsItem() {
  const [billDetails, setBillDetails] = useState({});
  const { id } = useParams();

  useEffect(() => {
    const newObject = billsAllData.find((item) => {
      return item.id === Number(id);
    });
    setBillDetails(newObject);
  }, []);


  const [isReverseBill, setIsReverseBill] = useState(false);
  const showReverseBill= () => {
    setIsReverseBill(true);
  };
  const handleOk = () => {
    setIsReverseBill(false)
  };
  const handleCancel = () => {
    setIsReverseBill(false)
  };

  const BillsItemRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod("Enter Bill", "1", "", "", "/accounting/payables_bills/bills/enter-bils"),
      RightBarMethod("Automated AP", "2", "", "", ""),
      RightBarMethod("Smart Bill Entry", "3", "", "", "/accounting/payables_bills/bills/smartbillentry"),
      RightBarMethod("Enter Utility Bill (RUBS)", "4", "", "", "/accounting/payables_bills/bills/utility-bill-details"),
      RightBarMethod("Enter Credit", "5", "", "", ""),
      RightBarMethod("Pay Bills", "6", "", "", ""),
      RightBarMethod("Tenant Payable", "7", "", "", "/accounting/payables_bills/bills/newtenantpayable"),
      RightBarMethod("New Recurring Bill", "8", "", "", "/accounting/payables_bills/recurring_invoices/newrecurringbill"),
      RightBarMethod("Manually Post Bills", "9", "", "", ""),
      RightBarMethod("Upload Bulk Bills", "10", "", "", "/accounting/payables_bills/bills/upload-bulk-bills"),
      RightBarMethod("Charge this Bill to Tenant", "11", "", "", ""),
      RightBarMethod("Copy Bill", "12", "", "", ""),
      RightBarMethod(<span onClick={showReverseBill}>Reverse Bill</span>, "13", "", "", ""),
    ]),
    RightBarMethod(
      "REPORTS",
      "t2",
      <i className="fa-solid fa-chart-column"></i>,
      [RightBarMethod("Vendor Ledger", "14", "", "", "/")]
    ),
    RightBarMethod(
      "HELP TOPICS",
      "t3",
      <i className="fa-solid fa-circle-question"></i>,
      [RightBarMethod("How to Refund Tenants", "15", "", "", "/")]
    ),
  ];
  
  return (
    <>
      <div className="bills-item">
        <GoBackLink link="/accounting/payables_bills" />
        <div className="parent">
          <PageHeading heading="Bill Details" />
          <div className="buttons-container">
            <Select defaultValue="Pay Bill Now" options={[{ value: "Pay Bill Now" }]} disabled />
            <button className="edit-btn">
              <FiEdit />
              <span>Edit</span>
            </button>
          </div>
        </div>
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <Card>
              <Form
                colon={false}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 11 }}
              >
                <Row>
                  <Col span={12}>
                    <Form.Item label="Payee">
                      <p>{billDetails?.payee}</p>
                    </Form.Item>
                    <Form.Item label="Reference">
                      <p>{billDetails?.reference}</p>
                    </Form.Item>
                    <Form.Item label="Remarks">
                      <p>{billDetails?.remarks}</p>
                    </Form.Item>
                    <Form.Item label="Memo For Check">
                      <p>{billDetails?.memoForCheck}</p>
                    </Form.Item>
                    <Form.Item label="Approval Status">
                      <p>{billDetails?.approvalStatus}</p>
                    </Form.Item>
                    <Form.Item label="Next Approver(s)">
                      <p>{billDetails?.nextAprrovers ? (billDetails.nextAprrovers.map((item, index) => <span key={index}>{item}, </span>)) : null}</p>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Bill Date">
                      <p>{billDetails?.billDate}</p>
                    </Form.Item>
                    <Form.Item label="Posting Date">
                      <p>{billDetails?.postingDate}</p>
                    </Form.Item>
                    <Form.Item label="Due Date">
                      <p>{billDetails?.dueDate}</p>
                    </Form.Item>
                    <Form.Item label="Total Amount">
                      <p>${billDetails?.amount}</p>
                    </Form.Item>
                    <Form.Item label="Cash Account">
                      <p>{billDetails?.cashAccount}</p>
                    </Form.Item>
                    <Form.Item label="Current Approval Step">
                      <p>{billDetails?.currentApprovalStep}</p>
                    </Form.Item>
                    <Form.Item label="Last Approved By">
                      <p>{billDetails?.lastApprovedBy}</p>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>
          <Col span={24}>
            <Card>
              <Row className="header-row">
                <Col span={6}>
                  <span>Property</span>
                </Col>
                <Col span={2}>
                  <span>Unit</span>
                </Col>
                <Col span={5}>
                  <span>GL Account</span>
                </Col>
                <Col span={4}>
                  <span>Description</span>
                </Col>
                <Col span={2}>
                  <span>Amount</span>
                </Col>
                <Col span={2}>
                  <span>Status</span>
                </Col>
                <Col span={3}>
                  <span>Pay Date</span>
                </Col>
              </Row>
              {
                billDetails?.payments ? (
                  billDetails.payments.map((item, index) => {
                    return (
                      <Row className="data-row" key={index}>
                        <Col span={6}>
                          <span>{item.property}</span>
                        </Col>
                        <Col span={2}>
                          <span>{item.unit}</span>
                        </Col>
                        <Col span={5}>
                          <span>{item.glAccount}</span>
                        </Col>
                        <Col span={4}>
                          <span>{item.description}</span>
                        </Col>
                        <Col span={2}>
                          <span>${item.amount}</span>
                        </Col>
                        <Col span={2}>
                          <span>{item.status}</span>
                        </Col>
                        <Col span={3}>
                          <span>{item.payDate}</span>
                        </Col>
                      </Row>
                    )
                  })
                ) : null
              }
            </Card>
          </Col>
          <Col span={24}>
            <Card title="Audit Log">
              <Row gutter={[0, 16]}>
                <Col span={24}>
                  <Form
                    colon={false}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 11 }}
                  >
                    <Form.Item label="Created By">
                      <p>
                        <span className="onclick-text">aamir</span> ali on
                        02/22/2023 06:37 AM
                      </p>
                    </Form.Item>
                    <Form.Item label="Last Saved By">
                      <p>
                        <span className="onclick-text">aamir</span> ali on
                        02/22/2023 06:37 AM
                      </p>
                    </Form.Item>
                  </Form>
                </Col>
                <Col span={24} className="audit-logs">
                  <Row gutter={[16, 0]}>
                    <Col>
                      <p>02/22/2023 06:37 AM</p>
                    </Col>
                    <Col>
                      <p>
                        <strong>Created Bill test test $10.00 -</strong>{" "}
                        <span className="onclick-text">aamir ali</span>
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col span={24}>
            <Card title="Approval Log">
              <Col span={24} className="approval-logs">
                <Row justify="center">
                  <Col>
                    <p>There are no approval logs at this time.</p>
                  </Col>
                </Row>
              </Col>
            </Card>
          </Col>
          <Col span={24}><Notes /></Col>
          {/* <Col span={24}><AttachmentsUpload /></Col> */}
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={BillsItemRightBar} />
      </div>


      <Modal
        title="Reverse Bill?"
        centered
        open={isReverseBill}
        footer={
          <div style={{ display: "flex", justifyContent: "start" }}>
            <Button type="primary" onClick={handleOk}>
            Reverse
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>

          </div>
        }
      >
        <Form>
          <Form.Item label="Reversal Date">
            <DatePicker format="MM-DD-YYYY" style={{width:'100%'}}/>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default BillsItem;
